import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyDashboardsEditRoute: InvariantJiraRoute = {
	name: 'legacy-dashboards-edit',
	path: '(/secure/|/)EditPortalPage([!%]?[\\w]*).jspa',
};
